import { DashboardWidget } from '../DashboardWidget/DashboardWidget';

const def: DashboardWidgetDefinition = {
    id: 'incongruent_portfolios',
    title: 'Incongruent Portfolios',
    type: 'portfolio',
    queryMeta: {
        dataVariant: 'report',
    },
    filters: [
        {
            id: 'isTaxable',
            value: false,
        },
        {
            id: 'isTaxLossHarvesting',
            value: true,
        },
    ],
    columnIds: ['aC', 'accountAlias', 'portfolioName', 'householdName', 'accountType'],
};

export const IncongruentPortfolios = () => <DashboardWidget widgetDefinition={def} />;
